import React from 'react'
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader'
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
// Table imports removed - now using CSS Grid via QuoteLayout

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import SkipNextIcon from '@mui/icons-material/SkipNextOutlined';
import SkipPrevIcon from '@mui/icons-material/SkipPreviousOutlined';

import { green,red } from '@mui/material/colors';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import {GetInstallationLocations, GetBatterys, GetTariffs, GetFlgFromID,
    APIQuoteUpdate, APIGetQuotes, APIGetEVChargers, APIGetAllInverters, APIAncillaryCosts,
    APIGetAllACControllers, APIGetSites, APIAddUpdateSites} from './Api'

import ErrorDialog from './ErrorDialog'
import CustomerCaptureForm from './components/CustomerCaptureForm'

import CalculationPage from './CalculationPage'
import CalcResults from './CalcResults'
import CustomerSiteList from './CustomerSites'

// New refactored tab components
import { EnergyTab, AddonsTab, BatteryInvertersTab, PanelsTab } from './components/tabs'
import { QuoteLayout } from './components/quote'

// Redux store actions for syncing with new slices
import {
    setElecConsumption, setElecRate, setElectricEstimated,
    setGasConsumption, setGasRate, setGasEstimated,
    setSelectedTariff, setTariffId, setSelfConsumption, updateEnergyFromQuote
} from './store/slices/energySlice'
import {
    setVoltageOptimiser, setIBoost, setSmartThermostat, setBoilerManager,
    setEVCharger, setEVBatterySize, setSoftGround, setHardGround, setDeliveryMiles,
    updateAddonsFromQuote
} from './store/slices/addonsSlice'
import {
    setBattery, setBatteryQty, setRequiredInverters, setPanelArrays, setSavings,
    setIs3Phase, setOffgrid, setHybrid, setStandardInverters, setACController,
    setBatteryOnly, updateSystemFromQuote
} from './store/slices/systemSlice'
import {
    setBatteries, setTariffs, setEVChargers, setInverters, setACControllers
} from './store/slices/catalogSlice'
import {
    setSystemCost, setNetCost, setVat, setHoldBasePrice, setFinanceOption,
    setFinanceTerm, setFinanceCharge, setCommPerc, setCommSacrifice,
    setAdditionalDiscount, setSharedDiscount, setSelectedMaintenance,
    setAncillaryItems, setOfferId, setDontUpdateBase, updateFinancialFromQuote
} from './store/slices/financialSlice'
import {
    setFlgId, setName, setFirstName, setEmail, setFullAddress, setPostcode,
    setRepName, setRepEmail, setAssignedRep, setSites, setSweepSale,
    setExtraOrderInfo, setSelfGen
} from './store/slices/customerSlice'

import pdf_config from './configs/pdf_configs'
import { NumericFormat as NumberFormat } from 'react-number-format';
import batterymaps from './batterymaps'
//import VisibilityIcon from '@mui/icons-material/Visibility';
//import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import packageInfo from '../package.json';

import { connect } from 'react-redux'
import { 
    updateelectric_estimated, 
    updateelecrate, 
    updateconservationarea,
    updatelistedproperty,
    updatedeposit,
    updaterepcustomermsg,
    updatecustomer2name,
    updatecustomer2surname,
    updatecustomer2title,
    updatecustomer2email,
    agreementcheckconfirmed,
    birdprotectionconfirmed,
    updatefinmonthlypayment,
    updatefintotalcost,
    updateagreementdata,
    updatempan,
    updatenoratedisclaimer,
    updatepropertytype,
    updateoffgridsystem,
    updateselectedsite
} from "./actions";
import pdf_configs from './configs/pdf_configs';
//import * as actions from './actions'

var batteries = []
var Tariffs = []
var evchargers = []
var inverters = []
var accontrollers = []
var installation_locations =  []
const vat_rate = pdf_config.vat_rate
// Get the FLG Record field if it exists or return a default value
const console_log = (text) => { 
    return  // Comment out if you want logging
    console_log(text)
}

const NF = (props) => {
    const cur = props.cur
    return (
        <NumberFormat  value={props.value} 
        displayType={'text'} 
        thousandSeparator={true} 
        decimalSeparator={'.'}
        decimalScale={props.value==parseInt(props.value) ? 0 : 2}
        fixedDecimalScale={true}
        prefix={cur ? cur : ''}  />
    )
}

// Create our Tab Panels for Our Tabs.
// THese will hold the Details of each Panel Array
const  TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    let selval = 0
    if(!isNaN(value)) selval = value
    return (
      <Typography
      className={styles.tabpanel}
        component="div"
        role="tabpanel"
        hidden={selval !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {selval === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
}
  
// Prop Type for the TabPanels
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
// Get The Props for the Selected Tab - Index denotes the selected tab
const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

const InverterSelect = (props) => {
    const lbl = 'lbl' + props.name
    let key = 0
    let name = `inverter_${key}`
    let overwrite = false
    if(typeof props.inverters[key].overwrite !== "undefined")
        overwrite = props.inverters[key].overwrite
    let filter = inverters.filter((item) => { return inverterFilter(item, props.is3phase, props.solaredge, props.offgrid, props.from, props.to, props.hybrid)})

    filter.unshift({_id: '', id: -2, description: 'No Inverter Required',  hybrid: false,  manufacturer: '',  outofstock: true, watts: 0})
    filter.unshift({_id: '', id: -1, description: 'Please Select An Inverter', hybrid: false,manufacturer: '', outofstock: true, watts: 0})
    let prevManu = ""
    let group_key = 0;
    let value = parseInt(props.value)
    
    return(
        <FormControl className={props.frmClass} >        
        <InputLabel id={lbl} >{props.title}</InputLabel>
        <Select
            labelid={lbl} 
            className={props.frmLabel}
            value={value}
            displayEmpty={true}
            onChange={props.onChange} 
            id= {name} 
            name={name} 
            >
            {
               filter.map((item) => { 
                var invtype="Hybrid"
                var invret = []
                let manu = item.manufacturer;
                if(typeof manu == "undefined") manu = ""
                if(!item.hybrid ) invtype="String"
                else if(manu.toUpperCase() == "SOLAREDGE") invtype="Solaredge"
                let inverter_text = `${item.watts}W ${manu} ${item.description} ${item.is3phase ? '3Phase' :  'Single Phase'} ${item.offgrid ? 'Off Grid' : ''} ${invtype} Inverter`
                if(item.id < 0) inverter_text = item.description
                 //const inverter_text = `${item.watts}W ${item.description} ${item.is3phase ? '3Phase' :  'Single Phase'} ${item.offgrid ? 'Off Grid' : ''} ${invtype} Inverter`
                if(manu !== prevManu) {
                    prevManu = item.manufacturer
                    group_key--;
                    invret.push(<ListSubheader key={group_key}>{manu}</ListSubheader> )
                }
                invret.push( 
                    <MenuItem idx={0} key={item.id} value={parseInt(item.id)} >
                        {!item.outofstock && item.id>=0 &&  <Icon style={{ color: green[500], fontSize: '14px' }}>done</Icon> }
                        {item.outofstock && item.id>=0 &&  <Icon style={{ color: red[500], fontSize: '14px' }}>do_not_disturb</Icon> }
                        <span style={{color: !item.outofstock ? "black" : "red", fontWeight: item.id<0 ? "bold" : "normal" }}>
                        {inverter_text} 
                        </span>
                    </MenuItem> )
                return(invret)
                })
            }
        </Select>
        <FormControlLabel
            className={props.frmLabel}
            control={<Checkbox  size="small" className={props.frmCheckbox} onChange={props.overWriteChange(props.idx)}  
            checked={overwrite}/>}
            label={<Typography className={props.frmLabel}>Overwrite Manual Seletion</Typography>}
            labelPlacement="start"
        />
        </FormControl>  
    )
}

const inverterFilter = (item, is3phase, solaredge, offgrid, from,to, hybrid ) => {
    const f = (Number(from)/1.3334)
    const t = (Number(to) *1.3334)
    if(item.id < 0 ) return false;
    if(solaredge && item.manufacturer == "SOLAREDGE") {  return true; }
    if(is3phase && !item.is3phase) { return false; }
    if(solaredge && item.manufacturer != "SOLAREDGE") {  return false; }
    if(offgrid && item.offgrid) {  return true; }
    if(offgrid && !item.offgrid) {  return false; }
    if(is3phase && item.is3phase) { return true; }
    if(!is3phase && item.is3phase) { return false; }
    if(!offgrid && item.offgrid) {  return false; }
    if(item.hybrid && !hybrid ) {  return false; }
    if(!item.hybrid  && hybrid) {  return false; }
    if(Number(item.watts) <= f) return false
    if(Number(item.watts) >= t) return false
    return true
}


const SmallColorButton = withStyles((theme) => ({
    root: {
      color: '#ffffff', 
      backgroundColor: '#04c659',
      '&:hover': {
        backgroundColor: '#04a659',
      },
      fontSize: '10px',
      paddingTop: '2px',
      paddingBottom: '2px',
      paddingLeft: '5px',
      paddingRight: '5px',
      marginLeft: '5px',
      marginRight: '5px'
    },
  }))(Button);

class QuotePageApp extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            errOpen: false,
            errText: '',
            errTitle: '',
            showCustomerCapture: false, // Show form when no FLG ID or FLG unavailable
            calculating: false,
            origprops: props,
            flg_id: props.flg_id,
            flg_rec: props.flg_rec,
            rep_name: props.rep_name,
            rep_email: props.rep_email,
            elecconsumption: 0,
            //elecrate: 0,
            gasconsumption: 0,
            gasrate: 0.00,
            //electric_estimated: true,
            gas_estimated: true,
            name: '',
            first_name: '',
            full_address: '',
            postcode: '',
            savings: [],
            orderref: 100,
            panelArrays: [],
            rest_token: null,
            battery: null, 
            evcharger: null,
            vo: false,                      // has a voltage optimiser
            boilermanager: false,
            iboost: false,
            smartthermostat: false,
            selfconsumption: 'mdg003_homeallday',        // % of Solar Energy that will be used by the household in the day
            systemcost: 10000,
            financeoption: null,
            finance: {},
            financeterm: 0,
            selected_tariff:    {},
            tariff_id: 0,
            update_flg: false,
            is_loading: true,
            hasError: false,
            error: '',
            Page: 0,
            mounted: false,
            slides: [],
            filelist: [],
            offerid: '7 Day Offer 5',
            selectedTab: 0,
            hardGround: 0,
            softGround: 0,
            evbatterysize: 0,
            required_inverters: [],
            is3phase: false,
            offgrid: false,
            standardinverters: true,
            net_cost: 0,
            selfgen: false,         // Self Generated Lead for commission purposed
            vat: vat_rate,                 // As defined in pdf_configs and defaults to residential base rate (Which may be 0%)
            commperc: 8,            // Default Comms Percentage 
            comm_sacrifice: 0,      // Any Reps Sacrificied commission due to offers etc
            additional_discount: 0, // Additional Discount offers
            delivery_miles: 100,
            finance_charge: 0,
            hardGround: 0,
            softGround: 0,
            create_documents: false,        // Only produces PDF Presentation and other docs when checked.
            dont_update_base: false,        // If Checked teh Base Price will not be updated from the Price Calculater.
            shared_discount: 0,             // Split Discount taken 50% WOS and 50% by Sales Rep.
            extra_order_info: '',
            presentation_versions: [],
            selected_presentation: `${props.flg_id}.pdf`,
            ancillary_items: [],
            confirm_batteryonly: false,
            batteryonly: false,
            accontroller: {},
            batteryonly_inv: 'string',
            hybrid: false,
            tmp_inverter: [{from: 0, to: 40000, inverter: {id:-2, description: 'No Inverter Required', manufacturer: '' }, id:-2, hybrid: true, is3phase:false, offgird: false, overwrite: true}],
            tmp_selected_inverter: -2,
            show_setup: true,
            show_results: true,
            email: '',
            hold_base_price: 0,
            popover: null,
            assigned_rep: '',    // The Rep the job was originally assigned to.
            sweep_sale: false,
            sites: [],           // Customer sites - Eg location of Install - There can be multiple sites per customer
            selectedsite: 0,
        }
    }

    handlePopoverOpen = (event) => {
        this.setState({popover: event.currentTarget})
    };
    
    handlePopoverClose = () => {
        this.setState({popover: null});
    };

    // Get default state for a new quote (no saved data)
    getDefaultQuoteState = ({ defaultBattery, defaultEvcharger, accontrollers, aits }) => {
        // Build default ancillary items
        const ancillary_items = [];
        if (aits) {
            aits.forEach(item => {
                if (item.input_field && item.fieldvar) {
                    const defaultValue = item.input_field_type === 'number' ? 0 : '';
                    ancillary_items.push({ key: item.fieldvar, value: defaultValue });
                }
            });
        }

        return {
            origprops: this.props,
            // Energy
            elecconsumption: 0,
            elecrate: 0, // Rate in PENCE (e.g., 21 for 21p/kWh)
            gasconsumption: 0,
            gasrate: 0,
            gas_estimated: true,
            electric_estimated: true,
            selected_tariff: {},
            tariff_id: 0,
            selfconsumption: 'mdg003_homeallday',
            // Addons
            vo: false,
            iboost: false,
            smartthermostat: false,
            boilermanager: false,
            evcharger: defaultEvcharger || null,
            evbatterysize: 0,
            softGround: 0,
            hardGround: 0,
            delivery_miles: 100,
            // System
            battery: defaultBattery || null,
            panelArrays: this.state.panelArrays,
            required_inverters: [],
            accontroller: accontrollers?.[0] || {},
            offgrid: false,
            is3phase: false,
            hybrid: true,
            standardinverters: false,
            batteryonly: false,
            batteryonly_inv: 'string',
            // Financial
            systemcost: 10000.00,
            net_cost: 0,
            vat: vat_rate,
            finance_charge: 0,
            financeterm: 0,
            financeoption: null,
            finance: {},
            commperc: 8,
            comm_sacrifice: 0,
            additional_discount: 0,
            shared_discount: 0,
            hold_base_price: 0,
            selected_maintenance: null,
            ancillary_items,
            offerid: '7 Day Offer 5',
            // Documents/Presentation
            slides: null,
            filelist: [],
            create_documents: false,
            dont_update_base: false,
            presentation_versions: null,
            selected_presentation: null,
            // Other
            selfgen: false,
            sweep_sale: false,
            extra_order_info: '',
            update_flg: true
        };
    };

    // Build state from a saved quote in MongoDB
    buildStateFromSavedQuote = (save_state, { batteries, accontrollers, defaultEvcharger, aits, installation_locations }) => {
        // Handle battery conversion for legacy quotes
        let ssbattery = {};
        if (!save_state.battery) {
            const noBattery = batteries.find(x => x.battery_id === 1);
            if (noBattery) ssbattery = JSON.parse(JSON.stringify(noBattery));
            ssbattery.converted = true;
        } else {
            ssbattery = JSON.parse(JSON.stringify(save_state.battery));
        }

        // Check if battery needs conversion (legacy mapping)
        if (ssbattery && !ssbattery.converted) {
            const mapping = batterymaps.find(item => item.battery_id === ssbattery.battery_id);
            if (mapping) {
                const newBattery = batteries.find(item => item.battery_id === mapping.Mapsto);
                if (newBattery) {
                    ssbattery = JSON.parse(JSON.stringify(newBattery));
                    ssbattery.Qty = mapping.Qty > 0 ? mapping.Qty : 1;
                    ssbattery.converted = true;
                }
            }
        }
        if (ssbattery && !ssbattery.Qty) ssbattery.Qty = 1;

        // Build ancillary items
        let ancillary_items = save_state.ancillary_items || [];
        if (aits) {
            aits.forEach(item => {
                if (item.input_field && item.fieldvar) {
                    // Check for legacy individual fields
                    if (save_state[item.fieldvar] !== undefined) {
                        const existing = ancillary_items.find(x => x.key === item.fieldvar);
                        if (existing) {
                            existing.value = save_state[item.fieldvar];
                        } else {
                            ancillary_items.push({ key: item.fieldvar, value: save_state[item.fieldvar] });
                        }
                    } else if (!ancillary_items.find(x => x.key === item.fieldvar)) {
                        const defaultValue = item.input_field_type === 'number' ? 0 : '';
                        ancillary_items.push({ key: item.fieldvar, value: defaultValue });
                    }
                }
            });
        }

        // Update panel arrays with installation locations
        let panelArrays = save_state.panelArrays ? JSON.parse(JSON.stringify(save_state.panelArrays)) : [];
        panelArrays.forEach(panel => {
            const panloc = panel.installation_location || {};
            if (!(panloc.flatroof ?? false) || !(panloc.groundmount ?? false)) {
                const instloc = installation_locations?.find(il => panloc.installation_id === il.installation_id);
                if (instloc) panel.installation_location = instloc;
            }
            // Back-fill railColour default for quotes saved before the per-array rail colour feature.
            if (!panel.railColour) panel.railColour = 'silver';
        });

        // Determine inverter type
        let standardinverters = false;
        let hybrid = save_state.hybrid ?? false;
        if (!hybrid && !save_state.is3phase && !save_state.offgrid) {
            standardinverters = true;
        }

        return {
            origprops: save_state.origprops ? JSON.parse(JSON.stringify(save_state.origprops)) : this.props,
            // Energy - ALL from MongoDB (check both new and legacy field names)
            elecconsumption: save_state.elecConsumption ?? save_state.elecconsumption ?? 0,
            elecrate: save_state.elecRate ?? save_state.elecrate ?? 0, // FIXED: Was missing!
            gasconsumption: save_state.gasConsumption ?? save_state.gasconsumption ?? 0,
            gasrate: save_state.gasRate ?? save_state.gasrate ?? 0,
            gas_estimated: save_state.gasEstimated ?? save_state.gas_estimated ?? true,
            electric_estimated: save_state.electricEstimated ?? save_state.electric_estimated ?? true,
            selected_tariff: save_state.selectedTariff ?? save_state.selected_tariff ?? {},
            tariff_id: save_state.tariffId ?? save_state.tariff_id ?? 0,
            selfconsumption: save_state.selfConsumption ?? save_state.selfconsumption ?? 'mdg003_homeallday',
            // Addons - ALL from MongoDB (check both new and legacy field names)
            vo: save_state.voltageOptimiser ?? save_state.vo ?? false,
            iboost: save_state.iBoost ?? save_state.iboost ?? false,
            smartthermostat: save_state.smartThermostat ?? save_state.smartthermostat ?? false,
            boilermanager: save_state.boilerManager ?? save_state.boilermanager ?? false,
            evcharger: save_state.evCharger ?? save_state.evcharger ? JSON.parse(JSON.stringify(save_state.evCharger ?? save_state.evcharger)) : defaultEvcharger,
            evbatterysize: save_state.evBatterySize ?? save_state.evbatterysize ?? 0,
            softGround: save_state.softGround ?? 0,
            hardGround: save_state.hardGround ?? 0,
            delivery_miles: save_state.deliveryMiles ?? save_state.delivery_miles ?? 100,
            // System - ALL from MongoDB (check both new and legacy field names)
            battery: JSON.parse(JSON.stringify(ssbattery)),
            panelArrays, // Already handled above with layoutSets preserved
            required_inverters: save_state.requiredInverters ?? save_state.required_inverters ? JSON.parse(JSON.stringify(save_state.requiredInverters ?? save_state.required_inverters)) : [],
            accontroller: save_state.acController ?? save_state.accontroller ?? accontrollers?.[0] ?? {},
            offgrid: save_state.offgrid ?? false,
            is3phase: save_state.is3Phase ?? save_state.is3phase ?? false,
            hybrid: save_state.hybrid ?? hybrid,
            standardinverters: save_state.standardInverters ?? standardinverters,
            batteryonly: save_state.batteryOnly ?? save_state.batteryonly ?? false,
            batteryonly_inv: save_state.batteryOnlyInverterType ?? save_state.batteryonly_inv ?? 'string',
            // Financial - ALL from MongoDB (check both new and legacy field names)
            systemcost: save_state.systemCost ?? save_state.systemcost > 0 ? (save_state.systemCost ?? save_state.systemcost) : 10000.00,
            net_cost: save_state.netCost ?? save_state.net_cost ?? 0,
            vat: save_state.vat > 0 ? save_state.vat : vat_rate,
            finance_charge: save_state.financeCharge ?? save_state.finance_charge ?? 0,
            financeterm: save_state.financeTerm ?? save_state.financeterm ?? 0,
            financeoption: save_state.financeOption ?? save_state.financeoption ? JSON.parse(JSON.stringify(save_state.financeOption ?? save_state.financeoption)) : null,
            finance: save_state.finance ? JSON.parse(JSON.stringify(save_state.finance)) : {},
            commperc: save_state.commPerc ?? save_state.commperc ?? 8,
            comm_sacrifice: save_state.commSacrifice ?? save_state.comm_sacrifice ?? 0,
            additional_discount: save_state.additionalDiscount ?? save_state.additional_discount ?? 0,
            shared_discount: save_state.sharedDiscount ?? save_state.shared_discount ?? 0,
            hold_base_price: save_state.holdBasePrice ?? save_state.hold_base_price ?? 0,
            selected_maintenance: save_state.selectedMaintenance ?? save_state.selected_maintenance ? JSON.parse(JSON.stringify(save_state.selectedMaintenance ?? save_state.selected_maintenance)) : null,
            ancillary_items: save_state.ancillaryItems ?? ancillary_items,
            offerid: save_state.offerId ?? save_state.offerid ?? '7 Day Offer 5',
            // Documents/Presentation
            slides: save_state.slides ?? null,
            filelist: save_state.filelist ? JSON.parse(JSON.stringify(save_state.filelist)) : [],
            create_documents: save_state.create_documents ?? false,
            dont_update_base: save_state.dont_update_base ?? false,
            presentation_versions: save_state.presentation_versions ?? null,
            selected_presentation: save_state.selected_presentation ?? null,
            // Other
            selfgen: save_state.selfgen ?? false,
            sweep_sale: save_state.sweep_sale ?? false,
            extra_order_info: save_state.extra_order_info ?? '',
            update_flg: true
        };
    };

    // Update legacy Redux reducers from saved quote (still needed for some components)
    updateLegacyReduxFromQuote = (save_state) => {
        this.props.updateelecrate(save_state.elecrate ?? '');
        this.props.updateelectric_estimated(save_state.electric_estimated ?? true);
        this.props.updateconservationarea(save_state.conservation_area ?? false);
        this.props.updatelistedproperty(save_state.listed_property ?? false);
        this.props.updatedeposit(save_state.deposit_amount ?? 0.00);
        this.props.updaterepcustomermsg(save_state.customer_message_rep ?? '');
        this.props.updatecustomer2name(save_state.customer2name ?? '');
        this.props.updatecustomer2surname(save_state.customer2surname ?? '');
        this.props.updatecustomer2title(save_state.customer2title ?? '');
        this.props.updatecustomer2email(save_state.customer2email ?? '');
        this.props.agreementcheckconfirmed(save_state.agreement_confirmsend ?? false);
        this.props.updateoffgridsystem(save_state.offgrid_system ?? false);
        this.props.birdprotectionconfirmed(save_state.birdprotection_confirmsend ?? false);
        this.props.updatefinmonthlypayment(save_state.fin_monthlypayment ?? 0.00);
        this.props.updatefintotalcost(save_state.fin_totalcost ?? 0.00);
        this.props.updateagreementdata(save_state.agreementdata ?? null);
        this.props.updatempan(save_state.mpan_number ?? '');
        this.props.updatenoratedisclaimer(save_state.noratedisclaimer ?? false);
        this.props.updatepropertytype(save_state.propertytype ?? 'Residential');
    };

    // Sync component state to Redux slices (single source of truth)
    // IMPORTANT: Only call this on INITIAL LOAD - not on subsequent updates!
    // The new tab components (EnergyTab, AddonsTab, etc.) now manage their own Redux state directly.
    // Calling this after user edits would OVERWRITE their changes with stale this.state values.
    syncStateToRedux = (isInitialLoad = false) => {
        const { dispatch, energySlice, systemSlice, addonsSlice } = this.props;
        const state = this.state;

        // Customer slice - always safe to sync (not edited by tab components)
        dispatch(setFlgId(state.flg_id));
        dispatch(setName(state.name));
        dispatch(setFirstName(state.first_name));
        dispatch(setEmail(state.email));
        dispatch(setFullAddress(state.full_address));
        dispatch(setPostcode(state.postcode));
        dispatch(setRepName(state.rep_name));
        dispatch(setRepEmail(state.rep_email));
        dispatch(setAssignedRep(state.assigned_rep || ''));
        dispatch(setSites(state.sites || []));
        dispatch(setSweepSale(state.sweep_sale || false));
        dispatch(setExtraOrderInfo(state.extra_order_info || ''));
        dispatch(setSelfGen(state.selfgen || false));

        // Energy slice - ONLY sync on initial load, otherwise preserve Redux values
        // (EnergyTab manages these directly via Redux)
        if (isInitialLoad) {
            dispatch(updateEnergyFromQuote({
                elecconsumption: state.elecconsumption,
                elecrate: state.elecrate,
                electric_estimated: state.electric_estimated,
                selected_tariff: state.selected_tariff,
                tariff_id: state.tariff_id,
                selfconsumption: state.selfconsumption,
                gasconsumption: state.gasconsumption,
                gasrate: state.gasrate,
                gas_estimated: state.gas_estimated
            }));
        }

        // Addons slice - ONLY sync on initial load
        // (AddonsTab manages these directly via Redux)
        if (isInitialLoad) {
            dispatch(updateAddonsFromQuote({
                vo: state.vo,
                iboost: state.iboost,
                smartthermostat: state.smartthermostat,
                boilermanager: state.boilermanager,
                evcharger: state.evcharger,
                evbatterysize: state.evbatterysize,
                softGround: state.softGround,
                hardGround: state.hardGround,
                delivery_miles: state.delivery_miles
            }));
        }

        // System slice - sync panelArrays and other system data
        // (PanelsTab manages panelArrays directly, but we still need to sync other system values)
        // BatteryInvertersTab manages battery directly via Redux, so preserve Redux value if it exists
        dispatch(updateSystemFromQuote({
            battery: systemSlice?.battery || state.battery,
            // Only sync panelArrays from state if Redux is empty (initial load)
            // Otherwise preserve Redux panelArrays which may have layoutSets updates
            panelArrays: (systemSlice?.panelArrays?.length > 0) ? systemSlice.panelArrays : state.panelArrays,
            savings: state.savings,
            required_inverters: state.required_inverters,
            is3phase: state.is3phase,
            offgrid: state.offgrid,
            hybrid: state.hybrid,
            standardinverters: state.standardinverters,
            accontroller: state.accontroller,
            batteryonly: state.batteryonly
        }));

        // Financial slice - use bulk update
        dispatch(updateFinancialFromQuote({
            systemcost: state.systemcost,
            net_cost: state.net_cost,
            vat: state.vat,
            hold_base_price: state.hold_base_price,
            financeoption: state.financeoption,
            financeterm: state.financeterm,
            finance_charge: state.finance_charge,
            commperc: state.commperc,
            comm_sacrifice: state.comm_sacrifice,
            additional_discount: state.additional_discount,
            shared_discount: state.shared_discount,
            ancillary_items: state.ancillary_items,
            offerid: state.offerid,
            dont_update_base: state.dont_update_base
        }));

        // Set maintenance separately (not in bulk update)
        dispatch(setSelectedMaintenance(state.selected_maintenance));
    };

    componentDidMount = async () => {
        try {
            this.setup30YearArray();

            // ============================================================
            // STEP 1: Load catalog data (batteries, inverters, tariffs, etc.)
            // ============================================================
            batteries = await GetBatterys();
            const defaultBattery = batteries.find(x => x.battery_id === 1); // "No Battery" option

            evchargers = await APIGetEVChargers();
            const defaultEvcharger = evchargers.find(x => x.uid === 0);

            Tariffs = await GetTariffs();
            installation_locations = await GetInstallationLocations();
            inverters = await APIGetAllInverters();
            accontrollers = await APIGetAllACControllers();

            // Sync catalog data to Redux store
            this.props.dispatch(setBatteries(batteries));
            this.props.dispatch(setTariffs(Tariffs));
            this.props.dispatch(setEVChargers(evchargers));
            this.props.dispatch(setInverters(inverters));
            this.props.dispatch(setACControllers(accontrollers));

            const flg_id = this.props.flg_id || 0;

            // ============================================================
            // STEP 2: Load FLG data - ONLY for customer name/address/contact
            // ============================================================
            let customerInfo = {
                name: '',
                first_name: '',
                email: '',
                full_address: '',
                postcode: '',
                assigned_rep: '',
                flg_rec: {}
            };

            let flgAvailable = false;

            // Only try FLG if we have a valid flg_id
            if (flg_id && flg_id > 0) {
                try {
                    const flgResponse = await GetFlgFromID(flg_id);
                    if (flgResponse && flgResponse.status && flgResponse.payload.message === "OK") {
                        const flg_rec = flgResponse.payload;
                        flgAvailable = true;

                        // Build full address from FLG fields
                        let full_address = flg_rec.address || '';
                        ['address2', 'address3', 'towncity', 'postcode'].forEach(field => {
                            if (flg_rec[field]) {
                                full_address += full_address ? ', ' + flg_rec[field] : flg_rec[field];
                            }
                        });

                        customerInfo = {
                            name: flg_rec.fullname || '',
                            first_name: flg_rec.firstname || '',
                            email: flg_rec.email || '',
                            full_address,
                            postcode: flg_rec.postcode || '',
                            assigned_rep: flg_rec.username || '',
                            flg_rec
                        };
                    }
                } catch (err) {
                    console.error('Failed to load FLG data:', err);
                    flgAvailable = false;
                }
            }

            // If no FLG ID or FLG unavailable, show customer capture form
            if (!flgAvailable) {
                // Still load catalog data to Redux for when form is submitted
                const aits = await APIAncillaryCosts();

                this.setState({
                    showCustomerCapture: true,
                    is_loading: false,
                    // Store catalog data for later use
                    _catalogData: { batteries, evchargers, Tariffs, inverters, accontrollers, aits, installation_locations }
                });
                return; // Exit early - form submission will continue the process
            }

            // ============================================================
            // STEP 3: Load sites and saved quote from MongoDB
            // ============================================================
            const sites = await APIGetSites(flg_id);
            const saved_quote = await APIGetQuotes(flg_id);
            let save_state = null;
            if (saved_quote) {
                try {
                    save_state = JSON.parse(saved_quote.state);
                } catch (e) {
                    console.error('Failed to parse saved quote:', e);
                }
            }

            // Load ancillary cost items for initialization
            const aits = await APIAncillaryCosts();

            // ============================================================
            // STEP 4: Build quote state - from MongoDB or defaults
            // ============================================================
            let quoteState;

            if (save_state && save_state.origprops) {
                // === EXISTING QUOTE: Load from MongoDB ===
                quoteState = this.buildStateFromSavedQuote(save_state, {
                    batteries,
                    accontrollers,
                    defaultEvcharger,
                    aits,
                    installation_locations
                });
            } else {
                // === NEW QUOTE: Use sensible defaults ===
                quoteState = this.getDefaultQuoteState({
                    defaultBattery,
                    defaultEvcharger,
                    accontrollers,
                    aits
                });
            }

            // ============================================================
            // STEP 5: Merge customer info with quote state and set state
            // ============================================================
            this.setState({
                ...quoteState,
                // Customer info from FLG (always use latest from CRM)
                flg_rec: customerInfo.flg_rec,
                flg_id,
                name: customerInfo.name,
                first_name: customerInfo.first_name,
                email: customerInfo.email,
                full_address: customerInfo.full_address,
                postcode: customerInfo.postcode,
                assigned_rep: customerInfo.assigned_rep,
                sites: sites || [],
                // Loading state
                is_loading: false,
                loaded: true,
                errOpen: false
            }, () => {
                // Sync all loaded state to Redux slices in the setState callback so
                // it runs before any child setState → updateSavings → DoFLGUpdate
                // cascade can read the still-empty energy/addons slices and wipe the
                // real values back to zero on save.
                this.syncStateToRedux(true);
                console.log('%c✅ State synced to Redux slices', 'background: blue; color: white; padding: 4px;');
            });

            // Update legacy Redux reducers from saved quote data
            if (save_state) {
                this.updateLegacyReduxFromQuote(save_state);
            } else {
                // Set defaults for legacy Redux
                this.props.updateelectric_estimated(true);
                this.props.updateelecrate('');
                this.props.updateconservationarea(false);
                this.props.updatelistedproperty(false);
                this.props.updatepropertytype('Residential');
            }

            await this.sleep(1000);

            // Debug: Initial position log after mount
            setTimeout(() => {
                console.log('%c🚀 INITIAL MOUNT - Logging positions', 'background: green; color: white; padding: 4px;');
                this.debugLogPositions(this.state.selectedTab);
            }, 500);

        }catch(e) {
            console.error('componentDidMount Failed in QuotePageApp.js')
            console.error(e)
            this.setState({ errTitle: 'Serious Error Report to IT', errText: `The Component did not Complete Mounting in QuotePageApp. This means that prices and presentations WILL BE incorrect. Please report this Error Urgently to the IT Department.  System Reported Error ${e} `,errOpen: true, is_loading: false })
        }
    }

    componentDidUpdate = (prevProps) => {
        var flds =[
            "elecrate", "electric_estimated", "conservation_area", 
            "listed_property","deposit_amount","save_redux","agreement_confirmsend","birdprotection_confirmsend","offgrid_system"

        ]
        var changed = false
        const fldslength = flds.length;
        for(let i=0 ; i<fldslength; i++) {
            if(typeof prevProps[flds[i]] !== "undefined" &&  prevProps[flds[i]]  != this.props[flds[i]]){
                changed = true
                break
            }else if(typeof prevProps[flds[i]] == "undefined" && this.props[flds[i]] > "") {
                changed = true
                break                
            }
        }
        if(changed) this.DoFLGUpdate()
    }

    
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        //this.setState({hasError: true })
        console.log('getDerivedStateFromError')
        console.log(error)
        return { hasError: true};
    }
    
    componentDidCatch = (error, errorInfo) => {
        // You can also log the error to an error reporting service
        console_log("componentDidCatch")
        console_log(error)
        console_log(errorInfo);
        this.setState({ errTitle: 'Serious Error Report to IT', errText: `The Component did not Complete Mounting in QuotePageApp. This means that prices and presentations WILL BE incorrect. Please report this Error Urgently to the IT Department.  System Reported Error ${error} - ${errorInfo}`,errOpen: true, is_loading: false })
    }
    // Debug function to log element positions
    debugLogPositions = (tabName) => {
        const tabLabels = ['Energy', 'Addons', 'Battery / Inverters', 'Panels'];
        console.group(`%c📍 TAB CHANGE: ${tabLabels[tabName] || tabName}`, 'background: #6fcae7; color: black; padding: 4px 8px; font-weight: bold;');

        // Get key elements
        const appBar = document.querySelector('[data-debug="appbar"]');
        const leftCell = document.querySelector('[data-debug="leftcell"]');
        const tabPanel = document.querySelector('[data-debug="tabpanel"]');
        const tableMain = document.querySelector('[data-debug="tablemain"]');
        const rightCell = document.querySelector('[data-debug="rightcell"]');

        const logElement = (name, el) => {
            if (el) {
                const rect = el.getBoundingClientRect();
                const styles = window.getComputedStyle(el);
                console.log(`%c${name}:`, 'font-weight: bold; color: #1e3a5f;');
                console.table({
                    'top': rect.top,
                    'left': rect.left,
                    'width': rect.width,
                    'height': rect.height,
                    'scrollHeight': el.scrollHeight,
                    'position': styles.position,
                    'verticalAlign': styles.verticalAlign,
                    'display': styles.display,
                });
            } else {
                console.log(`%c${name}: NOT FOUND`, 'color: red;');
            }
        };

        logElement('TableMain', tableMain);
        logElement('LeftCell', leftCell);
        logElement('AppBar', appBar);
        logElement('TabPanel', tabPanel);
        logElement('RightCell', rightCell);

        console.log('%cWindow scroll:', 'font-weight: bold;', { scrollX: window.scrollX, scrollY: window.scrollY });
        console.groupEnd();
    }

    // Tab has changed so uSwitch between detail and summary view
    handleTabChange = (event, value) => {
        this.setState({selectedTab: value}, () => {
            // Debug: log positions after state update and render
            setTimeout(() => this.debugLogPositions(value), 100);
        });
    }
    IsJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    // Set up our Array to show 30 year Quotation
    setup30YearArray = ()  => {
        var arr = []
        for(var i=0; i<30; i++)
        {
            arr.push( {
               year: i+1,                   // Year of Quote
               solar: 0.00,                 // Solar Savings
               extras: 0.00,                // Extra Savings - Eg Voltage Optimize
               battery: 0.00,               // Social Energy & Battery Savings
               total: 0.00,                 // Total savings for this year
               cumulative_solar: 0.00,      // Cumulative SolarSavings to this year
               cumulative_extra: 0.00,      // Cumulative Extras Savings to this year
               cumulative_battery: 0.00,    // Cumulative Battery Savings to this year
               cumulative_total: 0.00,      // Cumulative Total Savings to this year
               cost: 0.00,                  // Coat for his year
               anual: 0.00,                 // Cumulative P&L Posistion at this year
            });
        }
        this.setState({savings: [...arr]})

    }

        // Update the number of panels 
    handleUpdateBattery = (event) => {
        let selBattery = batteries.find(x => x.battery_id === event.target.value) 
        selBattery.Qty = 1
        this.setState({battery: selBattery}, () => {this.DoFLGUpdate(); })  
    }

    handleUpdateBatteryQty = (event) => {

        let selBattery = JSON.parse(JSON.stringify(this.state.battery))
        let Qty = event.target.value
        if(isNaN(Qty) || Qty <= 0) Qty = 1
        selBattery.Qty = (Qty??0)
        //console.log('handleUpdateBatteryQty')
        //console.log(selBattery)
        this.setState({battery: selBattery}, () => {this.DoFLGUpdate(); })   
    }

    handleUpdateACController = (event) => {
        this.selectAccController(event.target.value)
    }

    selectAccController = (item_id) => {
        let selACCC = accontrollers.find(x => x.item_id === item_id) 
        this.setState({accontroller: selACCC}) 
    }

    handleUpdateEVCharger = (event) => {
        let selEVC = evchargers.find(x => x.uid === event.target.value) 
        this.setState({evcharger: selEVC})  
    }
    // The Calculation Page has chaanged so lets update
    updatepanelArrays = e => {
        // Take a copy of the current panelArrays - DeepCopy
        let panelArrays = JSON.parse(JSON.stringify(e.panelArrays))
        let softGround = e.softGround
        let hardGround = e.hardGround
        //make changes to panelArrays
        //console_log("hardGround,softGround:  " + hardGround + "," + softGround)
        this.setState({panelArrays, hardGround,softGround },
            () =>{
                // this.SelectACControllerForSolaredge()
                this.DoFLGUpdate()
                this.syncStateToRedux() // Keep Redux in sync
            }
        ) 
        
    }


    doupdateElecRate = e => { 
        this.props.updateelecrate(e.target.value)
    }

    handleTariffChange = (event) => {
        let selTariff = Tariffs.find(x => x.tariff_id === event.target.value)
        if(selTariff)
            this.setState({selected_tariff: selTariff, tariff_id: selTariff.tariff_id}) 
        else 
            this.setState({selected_tariff: null, tariff_id: null}) 
    }

    UpdateElecConsumption = e => {
        this.setState({elecconsumption: e.target.value},console_log('elecconsumption ' + this.state.elecconsumption));
    }

    handleAdditionsChange = name => event => {
        switch(name) {
            case 'electric_estimated':
                this.props.updateelectric_estimated(event.target.checked)
                break;
            default:
                this.setState({ [name]: event.target.checked });
                break;
        }
    };

    handleBatteryOnly = name => event => {
        this.setState({ errTitle: "Confirm This Is A Battery Only Sale ?",
                        errText: "By Selecting a Battery Only Sale any Solar Panel or Inverter settings for this customer will be lost. Are you sure you wish to continue?",
                        confirm_batteryonly: true
                    })
    }

    handleConfirmBatteryOnly = name => {
        if(!name)
            this.setState({confirm_batteryonly: false, errText: "", errTitle: ""})
        else {
            try {
                this.updateBatteryOnlyInverters()
                this.setState(
                    {confirm_batteryonly: false, errText: "", errTitle: "", batteryonly: !this.state.batteryonly}, 
                    () => { this.updateBatteryOnlyInverters() }
                )  
            }catch(err) {
                console.log(`catch error ${err}`)
                this.setState({confirm_batteryonly: false, errText: "", errTitle: ""})              
            }
        }
    }

    updateBatteryOnlyInverters = () => {
        if(this.state.batteryonly) {
            try{
                // See if we are using Solar Edge
                var totalsize = 0
                var solaredge=false
                var prefmanufacturer = ""
                if(this.state.offerid == "7 Day Offer 2") 
                    prefmanufacturer = ""
                const statepanArraylength = this.state.panelArrays.length;
                for(var i=0; i<statepanArraylength; i++) {
                    if(typeof this.state.panelArrays[i].optimiser !== "undefined" && this.state.panelArrays[i].optimiser.type == "SE")
                        solaredge = true
                    totalsize += (this.state.panelArrays[i].watts * this.state.panelArrays[i].numPanels)    
                }
                let inverters = [];
                if(this.state.batteryonly_inv == 'hybrid')
                    inverters.push({overwrite: true, from: 1000, to: 6000, hybrid: true, solaredge: false, is3phase: this.state.is3phase, offgrid: this.state.offgrid,inverter: {},prefmanufacturer})
                else
                    inverters.push({overwrite: true, from: 1000, to: 40000, hybrid: false, solaredge, is3phase: this.state.is3phase, offgrid: this.state.offgrid,inverter: {},prefmanufacturer})

                this.setState({required_inverters: inverters})  
            }catch(err) {
                console.log(err)
            }
        }else {
            this.setState({required_inverters: []}) 
        }
    }

    handleUpdateBatteryOnlyInvType = event => {
        this.setState({
                batteryonly_inv: event.target.value},
                () => { this.updateBatteryOnlyInverters() }
        )
    }

    handlePowerTypes = name => event => {
        if(name == 'standardinverters' ) {
            this.setState({ [name]: true, is3phase: false, offgrid: false, hybrid: false });
        }else if(name =='hybrid') {
            this.setState({ [name]: true, is3phase: false, offgrid: false, standardinverters: false });
        }else if(name == 'offgrid') {
            this.setState({ [name]: true, is3phase: false, standardinverters: false, hybrid: false });
        }else {
            this.setState({ [name]: true, offgrid: false,  standardinverters: false, hybrid: false });
        }
    }

    handleGroundWorksChange = name => event => {
        var m = event.target.value
        if(isNaN(m) || m == "") m = 0
        this.setState({ [name]: m });
        var {hardGround,softGround} = this.state
        if(name=='hardGround') hardGround = m
        if(name=='softGround') softGround = m
        // this.props.onChange({panelArrays: this.state.panelArrays, origprops: this.props, hardGround, softGround})
    }

    handleSelfConsumptionChange = e => {
        this.setState({selfconsumption: e.target.value})
    }
    
    UpdateGasConsumption = e => {
        this.setState({gasconsumption: e.target.value})
    }
    
    UpdateGasRate = e =>{
        console_log("Update Gas Rate to " + e.target.value)
        this.setState({gasrate: e.target.value})
    }
    
    updateSavings = async e => {
        console_log("*** updateSavings in => QuotePageApp")
        console_log(e)
        console_log(`updateSavings e.ancillary_items = ${e.ancillary_items}`)

        if(e.financeterm === this.state.financeterm && 
            //e.panelArrays === this.state.panelArrays 
            e.savings === this.state.savings && e.financeoption === this.state.financeoption &&
            e.slides === this.state.slides && e.filelist === this.state.filelist && e.offerid === this.state.offerid &&
            e.selected_maintenance === this.selected_maintenance && e.systemcost === this.state.systemcost &&
            e.required_inverters === this.state.required_inverters &&
            e.net_cost === this.state.net_cost &&
            e.selfgen === this.state.selfgen &&
            e.vat === this.state.vat &&
            e.finance_charge === this.finance_charge &&
            e.commperc === this.state.commperc &&
            e.comm_sacrifice === this.state.comm_sacrifice &&
            e.additional_discount === this.state.additional_discount &&
            e.delivery_miles === this.state.delivery_miles &&
            e.create_documents === this.state.create_documents &&
            e.dont_update_base === this.state.dont_update_base &&
            e.shared_discount === this.state.shared_discount &&
            e.extra_order_info === this.state.extra_order_info &&
            e.presentation_versions === this.state.presentation_versions &&
            e.selected_presentation === this.state.selected_presentation &&
            e.hold_base_price === this.state.hold_base_price &&
            e.sweep_sale === this.state.sweep_sale &&
            JSON.stringify(e.ancillary_items) === JSON.stringify(this.state.ancillary_items)
            ) {
                return;                
            }


        let panelArrays = e.panelArrays ? JSON.parse(JSON.stringify(e.panelArrays)) : this.state.panelArrays
        let savings = e.savings ? JSON.parse(JSON.stringify(e.savings)) : this.state.savings
        let financeoption = e.financeoption ? JSON.parse(JSON.stringify(e.financeoption)) : this.state.financeoption
        let financeterm = typeof e.financeterm !== "undefined" ? e.financeterm : this.state.financeterm
        let selected_maintenance = e.selected_maintenance ? e.selected_maintenance: this.state.selected_maintenance
        let required_inverters = typeof e.required_inverters !== "undefined" ? JSON.parse(JSON.stringify(e.required_inverters)) : []
        let net_cost = e.net_cost??0
        let selfgen = e.selfgen??0
        let vat = typeof e.vat !== "undefined" && e.vat > 0 ? e.vat  : vat_rate
        let finance_charge = 0 // typeof e.finance_charge !== "undefined" && e.finance_charge > 0 ? e.finance_charge : 0
        let commperc = e.commperc??0
        let comm_sacrifice = e.comm_sacrifice??0
        let additional_discount = e.additional_discount??0
        let delivery_miles = e.delivery_miles??0

        let create_documents = e.create_documents??false
        let dont_update_base = e.dont_update_base??false
        let shared_discount   =  e.shared_discount??0
        let extra_order_info = e.extra_order_info??''
        let presentation_versions = e.presentation_versions??[]
        let selected_presentation = e.selected_presentation??`${this.state.flg_id}.pdf`
    
        let ancillary_items = typeof e.ancillary_items !== "undefined" ? e.ancillary_items : []
        let hold_base_price = e.hold_base_price??0
        let sweep_sale = e.sweep_sale??false
        

        try {
            required_inverters = JSON.parse(JSON.stringify(e.required_inverters))
        }catch(exception) {
            required_inverters = this.state.required_inverters
        }
        console_log("ancillary_items = ")
        console_log(ancillary_items)
        let sc = e.systemcost
        if(isNaN(sc) || sc == "") sc = 0

        let systemcost = sc 
        let slides = this.state.slides
        let filelist = e.filelist
        let offerid = e.offerid
        if(e.slides !== "undefined" && e.slides && e.slides.length > 0)
            slides = e.slides
        //make changes to state and wait for updates before committinf to FLG
        this.setState({panelArrays, savings, financeoption, financeterm, selected_maintenance, systemcost,slides,update_flg: true, filelist, offerid, required_inverters,
                        net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount,
                        extra_order_info,presentation_versions, selected_presentation, ancillary_items, finance_charge, hold_base_price, sweep_sale }, () => {
            this.DoFLGUpdate();
            this.syncStateToRedux(); // Keep Redux in sync
        })
    }

    SelectACControllerForSolaredge = () => {
        let solaredge = false
        let totalsize = 0
        const statepanArraylength = this.state.panelArrays.length;
        for(var i=0; i<statepanArraylength; i++) {
            if(typeof this.state.panelArrays[i].optimiser !== "undefined" && this.state.panelArrays[i].optimiser.type == "SE") {
                solaredge = true
                break;
            }
        }

        if(solaredge && this.state.battery && typeof this.state.battery !== "undefined" && this.state.battery.battery_id > 1) {
            if(this.state.accontroller && typeof this.state.accontroller !== "undefined" && this.state.accontroller.item_id !== -1)
                return
            // By Default select a Growat AC Controller when we switch to SolarEdge
            this.selectAccController(10)
        }
    }

    // Sleep for x milliseconds - must be called with await from an Async Function
    sleep = async (x) => {
            return new Promise( resolve => setTimeout(resolve, x));
    }

    // Save quote data to MongoDB only (no longer saving to FLG data fields)
    DoFLGUpdate = async () => {
        if (!this.state.update_flg) {
            console_log("update_flag not set in DoFLGUpdate")
            return;
        }

        // Get data from new Redux slices (these are the source of truth for updated components)
        const { energySlice, systemSlice, addonsSlice, financialSlice, customerSlice } = this.props;

        // Save quote to MongoDB Database only
        // FLG is now only used for customer name/address/contact - not quote data
        // Exclude popover from state as it contains a DOM element that can't be serialized
        const { popover, ...serializableState } = this.state;
        const json_state = JSON.stringify({
            ...serializableState,

            // NEW REDUX SLICES - Primary source of truth for refactored components
            // Energy data (from EnergyTab)
            elecConsumption: energySlice?.elecConsumption,
            elecRate: energySlice?.elecRate,
            elecrate: energySlice?.elecRate, // Legacy field name for backwards compatibility
            electricEstimated: energySlice?.electricEstimated,
            electric_estimated: energySlice?.electricEstimated,
            gasConsumption: energySlice?.gasConsumption,
            gasRate: energySlice?.gasRate,
            gasEstimated: energySlice?.gasEstimated,
            selectedTariff: energySlice?.selectedTariff,
            tariffId: energySlice?.tariffId,
            selfConsumption: energySlice?.selfConsumption,

            // System data (from PanelsTab, BatteryInvertersTab)
            panelArrays: systemSlice?.panelArrays || this.state.panelArrays, // Include layoutSets!
            battery: systemSlice?.battery || this.state.battery,
            batteryQty: systemSlice?.batteryQty,
            batteryOnly: systemSlice?.batteryOnly,
            requiredInverters: systemSlice?.requiredInverters || this.state.required_inverters,
            is3Phase: systemSlice?.is3Phase,
            is3phase: systemSlice?.is3Phase,
            offgrid: systemSlice?.offgrid,
            hybrid: systemSlice?.hybrid,
            standardInverters: systemSlice?.standardInverters,
            acController: systemSlice?.acController,
            savings: systemSlice?.savings || this.state.savings,

            // Addons data (from AddonsTab)
            voltageOptimiser: addonsSlice?.voltageOptimiser,
            iBoost: addonsSlice?.iBoost,
            smartThermostat: addonsSlice?.smartThermostat,
            boilerManager: addonsSlice?.boilerManager,
            evCharger: addonsSlice?.evCharger,
            evcharger: addonsSlice?.evCharger, // Legacy field name
            evBatterySize: addonsSlice?.evBatterySize,
            softGround: addonsSlice?.softGround,
            hardGround: addonsSlice?.hardGround,
            deliveryMiles: addonsSlice?.deliveryMiles,

            // Financial data
            systemCost: financialSlice?.systemCost,
            netCost: financialSlice?.netCost,
            vat: financialSlice?.vat,
            financeOption: financialSlice?.financeOption,
            financeTerm: financialSlice?.financeTerm,
            financeCharge: financialSlice?.financeCharge,
            commPerc: financialSlice?.commPerc,
            additionalDiscount: financialSlice?.additionalDiscount,
            sharedDiscount: financialSlice?.sharedDiscount,
            selectedMaintenance: financialSlice?.selectedMaintenance,
            ancillaryItems: financialSlice?.ancillaryItems,

            // Customer data
            customerName: customerSlice?.name,
            customerEmail: customerSlice?.email,
            sites: customerSlice?.sites,

            // LEGACY Redux props - still needed by some components
            conservation_area: this.props.conservation_area,
            listed_property: this.props.listed_property,
            deposit_amount: this.props.deposit_amount,
            customer_message_rep: this.props.customer_message_rep,
            customer2name: this.props.customer2name,
            customer2surname: this.props.customer2surname,
            customer2title: this.props.customer2title,
            customer2email: this.props.customer2email,
            agreement_confirmsend: this.props.agreement_confirmsend,
            birdprotection_confirmsend: this.props.birdprotection_confirmsend,
            fin_totalcost: this.props.fin_totalcost,
            fin_monthlypayment: this.props.fin_monthlypayment,
            agreementdata: this.props.agreementdata,
            mpan_number: this.props.mpan_number,
            noratedisclaimer: this.props.noratedisclaimer,
            propertytype: this.props.propertytype,
            offgrid_system: this.props.offgrid_system
        });

        const json_props = JSON.stringify(this.props);
        await APIQuoteUpdate(this.state.flg_id, this.state.selectedsite, json_state, json_props);
    }

    // Close Error Dialog
    handleErrDialogClose = () => {
        this.setState({errOpen: false, errText: "", errTitle: ""})
    }

    // Handle customer capture form submission (when no FLG ID or FLG unavailable)
    handleCustomerCaptureSubmit = async ({ customerInfo, siteData }) => {
        const { dispatch } = this.props;

        // Update Redux customer slice with captured info
        dispatch(setName(customerInfo.name));
        dispatch(setFirstName(customerInfo.first_name));
        dispatch(setEmail(customerInfo.email));
        dispatch(setFullAddress(customerInfo.full_address));
        dispatch(setPostcode(customerInfo.postcode));
        dispatch(setAssignedRep(customerInfo.assigned_rep));

        // Set up the site
        const sites = [siteData];
        dispatch(setSites(sites));

        // Get catalog data from state (loaded in componentDidMount)
        const { batteries: batt, evchargers: evc, Tariffs: tar, inverters: inv,
                accontrollers: acc, aits, installation_locations: loc } = this.state._catalogData || {};

        // Set catalog data in Redux
        if (batt) dispatch(setBatteries(batt));
        if (tar) dispatch(setTariffs(tar));
        if (evc) dispatch(setEVChargers(evc));
        if (inv) dispatch(setInverters(inv));
        if (acc) dispatch(setACControllers(acc));

        // Update module-level variables (legacy support)
        if (batt) batteries = batt;
        if (tar) Tariffs = tar;
        if (evc) evchargers = evc;
        if (inv) inverters = inv;
        if (acc) accontrollers = acc;
        if (loc) installation_locations = loc;

        // Get default state for a new quote
        const defaultBattery = batt && batt.length > 0 ? batt[0] : null;
        const defaultEvcharger = evc && evc.length > 0 ? evc[0] : null;
        const defaultState = this.getDefaultQuoteState({
            defaultBattery,
            defaultEvcharger,
            accontrollers: acc || [],
            aits: aits || []
        });

        // Generate a temporary FLG ID for this session (will be used for quote storage)
        const tempFlgId = `MANUAL_${Date.now()}`;
        dispatch(setFlgId(tempFlgId));

        // Set the state with customer info and defaults
        this.setState({
            ...defaultState,
            showCustomerCapture: false,
            is_loading: false,
            flg_id: tempFlgId,
            flg_rec: {},
            name: customerInfo.name,
            first_name: customerInfo.first_name,
            email: customerInfo.email,
            full_address: customerInfo.full_address,
            postcode: customerInfo.postcode,
            assigned_rep: '',
            sites: sites,
            selectedsite: 0,
            installation_locations: loc || []
        }, () => {
            // Sync all state to Redux after setting (initial load from form)
            this.syncStateToRedux(true);
        });
    }

    handleChangeInverter = (event, idx)  => {
        if(!idx && typeof idx == "undefined") return
        const id = idx.props.value
        const index = idx.props.idx
        if(id == -2) {
            let hybrid = this.state.batteryonly_inv == 'hybrid' ? true : false
            let inv = [{from: 750, to: 50000, hybrid: false, overwrite: false, is3phase: this.state.is3phase, offgrid: this.state.offgrid, inverter: {id: -2, description: "No Inverter Required", manufacturer: ""}}]
            
            this.setState({required_inverters: inv})
            return
        }
        const inv = inverters.find((item) => {return item.id == id})
        if(typeof inv !=="undefined" && inv) {
            let ri = JSON.parse(JSON.stringify(this.state.required_inverters))
            ri[index].inverter = JSON.parse(JSON.stringify(inv))
            this.setState({required_inverters: ri})
        }
    }

    // Handle Inverter change for Te=ransient Inverter
    handleChangeTempInverter = (event)  => {
        //if(!event && typeof event == "undefined") return
        const id = event.target.value
        //const index = idx.props.idx
        let tmpinv = JSON.parse(JSON.stringify(this.state.tmp_inverter))
        if(id < 0 ) return;
        const inv = inverters.find((item) => {return item.id == id})
        if(typeof inv !=="undefined" && inv) {
            tmpinv[0].inverter = JSON.parse(JSON.stringify(inv))
            tmpinv[0].id = inv.id
            tmpinv[0].hybrid = inv.hybrid
            tmpinv[0].is3phase = inv.is3phase
            tmpinv[0].offgrid = inv.offgrid
            this.setState({tmp_inverter: tmpinv, tmp_selected_inverter: id})
        }
    }   

    overWriteChange = (index) => (event) => {
        //let ri = JSON.parse(JSON.stringify(this.state.required_inverters))
        let ri = JSON.parse(JSON.stringify(this.state.tmp_inverter))
        if(ri && typeof ri !== "undefined" && typeof ri[index] !== "undefined") {
            if(typeof ri[index] !== "undefined" && typeof ri[index].overwrite !== "undefined")
                ri[index].overwrite = !ri[index].overwrite
            else
                ri[index].overwrite = false
            //this.setState({required_inverters: ri})
            this.setState({tmp_inverter: ri})
        }
    }

    toggleShowHide = () => {
        this.setState({show_setup: !this.state.show_setup})
    }

    toggleShowResults = () => {
        this.setState({show_results: !this.state.show_results})
    }
    addInverter = () => {
        //return;
        
        let ri = this.state.required_inverters
        ri.push(this.state.tmp_inverter[0])    
        this.setState({required_inverters: ri})

    }

    removeInverter = (idx) => {
        let ri = []
        const req_inverters_length = this.state.required_inverters.length;
        for(let i=0; i<req_inverters_length; i++) {
            if(i !== idx)
                ri.push(JSON.parse(JSON.stringify(this.state.required_inverters[i])))
        }
        this.setState({required_inverters: ri})   
    }

    handleOverwrite = (idx) => {

        let required_inverters = JSON.parse(JSON.stringify(this.state.required_inverters))
        let fnd = required_inverters[idx]

       if(fnd && typeof fnd !== "undefined") {
            fnd.overwrite = !fnd.overwrite
            this.setState({required_inverters})
       }
    }

    // Show the New/Edit and Copy Site Form
    showAddSite = () => { this.setState({showNewSite: true}) }
    showEditSite = () => { this.setState({showEditSite: true}) }
    showCopySite = () => {this.setState({showCopySite: true}) }

    // Add a new Site to the Customer Sites
    saveNewSite = (data) => {
        // API to Add New Site
        // API to get Site Data
        var sites = []
        this.setState({sites, showNewSite: false})
    } 

    saveEditSite = (data) => {
        // API to Add New Site
        // API to get Site Data
        var sites = []
        this.setState({sites, showEditSite: false})
    } 

    // Cancel button clicked for New Site or Editing Site Details
    cancelNewEditSite = () => { this.setState({showNewSite:false, showEditSite:false, showCopySite:false}) }

    SelectSite = (site_id) => {
        const  {address1,address2,address3,town,county,postcode} = this.state.sites[site_id].address
        const full_address = address1?address1 : ', ' + address2?`, ${address2}`:'' + address3?`, ${address2}`:'' +  town?`, ${town}`:''  + county?`, ${address2}`:''  + postcode?`, ${postcode}`:''
        const {title,first,last,email} = this.state.sites[site_id].contacts[site_id]
        let name = ''
        if(title > '') name = title
        if(first > '') name += ` ${first}`
        if(last > '') name += ` ${last}`
        this.props.updateselectedsite(site_id) // Update redux
        this.setState({selectedsite: site_id, full_address, address: full_address,full_name: name, postcode, email}); 

    }

    changeSelCopy = (sitecopyid) => { 
        console.log(`changeSelCopy set sitecopyid to ${sitecopyid}`)
        this.setState({sitecopyid})
    }

    // Save Customer site Data
    saveSite = async (siteData) => {
        const sites = this.state.sites
        let bkup_sites = [...sites]
        const found = sites.find(item => item.site_id === siteData.site_id)
        if(found) {
            console.log('saveSite updating site')
            const idx = sites.findIndex(item => item.site_id === siteData.site_id)
            if(idx) {
                bkup_sites[idx] = {...siteData, primarycontact: 0, flg_id: this.props.flg_id}
            }
        }else {
            console.log('adding site')
            bkup_sites.push({...siteData, primarycontact: 0, flg_id: this.props.flg_id})
        }

        this.setState({sites: bkup_sites},()=>this.cancelNewEditSite())
        let ret = await APIAddUpdateSites(this.state.flg_id, {...siteData, flg_id: this.state.flg_id,primarycontact: 0})
        console.log('APIAddUpdateSites')
        console.log(ret)
    }

    deleteSite = (site_id) => {
        if(site_id <0 ) return
        const site_index = this.state.sites.findIndex(item => item.site_id == site_id)
        const bkup_sites = [...this.state.sites]
        if(site_index < 0 ) return
        bkup_sites.splice(site_index,1)
        this.setState({sites: [...bkup_sites]})
    }
    // Taken out for now as might look a bit impersonable with a ref number
    // <span className={classes.quoteref} >(ref: {this.state.orderref} )</span> 
     render = () => {
        const { classes } = this.props;
        const { selected_tariff, panelArrays, errOpen, errTitle, errText} = this.state
        // Version info from package.json
        const versionInfo = {
            name: packageInfo.name,
            version: packageInfo.version,
            description: packageInfo.description
        }
        let sel_inverter = -1
        if( typeof this.state.tmp_inverter.inverter !== "undefined" )
            sel_inverter = this.state.tmp_inverter.inverter.id

        let {hardGround,softGround, evcharger} = this.state
        if(isNaN(hardGround) || hardGround == "") hardGround =0
        if(isNaN(softGround) || softGround == "") softGround =0
        var ss =0
        if(typeof this.state.savings[0] !== "undefined") ss = this.state.savings[0].system_size
        if(isNaN(ss) || ss<=0 ) {
            ss = 0
            const statepanArraylen = this.state.panelArrays.length;
            for(let pa=0; pa<statepanArraylen; pa++) 
                ss+=(this.state.panelArrays[pa].watts * this.state.panelArrays[pa].numPanels)
        }

        const systemsize = "Required for a " + Math.round(ss) + " Watts system"
        let tariff_id = this.state
        if( isNaN(tariff_id)) {
            tariff_id = selected_tariff.tariff_id
            if(isNaN(tariff_id))
                tariff_id  =0
        }
        let battery = this.state.battery
        if(!battery || typeof battery === "undefined") {
            battery = batteries[0]
        }
        let pman = ""
        const accontroller_id = typeof this.state.accontroller !== "undefined" ? this.state.accontroller.item_id : 0


        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
            <>
            <h1>Something went wrong.</h1>
                {this.state.error}
            </>
            )
        }
        if(errOpen==true && errTitle > "" && errText > "") {
            return (<ErrorDialog title={errTitle} text={errText} open={errOpen} onClose={this.handleErrDialogClose}  />) 
        }
        if(this.state.confirm_batteryonly==true && errTitle > "" && errText > "") {
            return ( <ErrorDialog title={this.state.errTitle} text={this.state.errText} open={(this.state.confirm_batteryonly && this.state.errTitle > "" & this.state.errText > "") ? true: false} onClose={this.handleConfirmBatteryOnly}  /> )
        }
        this.DoFLGUpdate()

        let is3phase= false
        let offgrid = false
        let solaredge = false
        let hybrid = false
                                    
        const popopen = Boolean(this.state.popover)
        if(typeof this.state.is3phase !== "undefined" )  is3phase = this.state.is3phase
        if(typeof this.state.solaredge !== "undefined" ) solaredge = this.state.solaredge 
        if(typeof this.state.offgrid !== "undefined" )   offgrid = this.state.offgrid
        if(typeof this.state.hybrid !== "undefined" ) hybrid = this.state.hybrid

        let Qty = 1
        if(typeof this.state.battery !== "undefined" && this.state.battery != null ) {
            if(typeof this.state.battery.Qty !== "undefined" )
                Qty = this.state.battery.Qty
                if(Qty <= 0 ) Qty = 1
        }

        // Show customer capture form when no FLG ID or FLG unavailable
        if (this.state.showCustomerCapture) {
            return (
                <CustomerCaptureForm
                    open={true}
                    onSubmit={this.handleCustomerCaptureSubmit}
                    onCancel={null}
                />
            )
        }

        if(this.state.is_loading )
            return (
                <Backdrop  open={this.state.is_loading} className={classes.backdrop} >
                    <CircularProgress color="inherit" size={100}/>
                </Backdrop>
            )
        return (
            <div className={classes.root} >
                <Grid container spacing={0} className={classes.topgrid} >
                    <Grid item xs={1} ><Typography className={classes.quote} >{this.state.show_setup &&                                 
                                <IconButton
                                    color="inherit"  size="small"
                                    onClick={this.toggleShowHide}
                                ><SkipPrevIcon fontSize="inherit" /></IconButton >  }
                                {!this.state.show_setup &&                                 
                                    <IconButton
                                        color="inherit"  size="small" onClick={this.toggleShowHide}
                                ><SkipNextIcon fontSize="inherit" /></IconButton >  }Quotation for:</Typography></Grid> 
                    <Grid item xs={6} ><Typography className={classes.quote} >{this.state.name} - {this.state.full_address} </Typography></Grid>
                    <Grid item xs={4} >
                    <Typography
                                        aria-owns={this.state.popover ? 'mouse-over-popover' : undefined}
                                        aria-haspopup="true"
                                        onMouseEnter={this.handlePopoverOpen}
                                        onMouseLeave={this.handlePopoverClose}
                                    >Version: {pdf_configs.live_version}</Typography>
                                    <Popover
                                        id="mouse-over-popover"
                                        className={classes.popover}
                                        classes={{paper: classes.paper,}}
                                        sx={{
                                            pointerEvents: 'none',
                                        }}
                                        open={popopen}
                                        anchorEl={this.state.popover}
                                        anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'center',
                                            horizontal: 'center',
                                        }}
                                        anchorReference='anchorEl'
                                        onClose={this.handlePopoverClose}
                                        disableRestoreFocus
                                    >
                                        <Typography className={classes.quote} ><br/>&nbsp;&nbsp;MT Solar Calculator Support Information&nbsp;&nbsp;&nbsp;<br/>
                                        &nbsp;&nbsp;Version: {versionInfo.version}<br/>&nbsp;&nbsp;{versionInfo.description}&nbsp;&nbsp;<br/>&nbsp;<br/></Typography>
                                    </Popover>
                    </Grid>
                </Grid>
                {/* New CSS Grid Layout replacing table-based layout */}
                <QuoteLayout
                    showLeftPanel={this.state.show_setup}
                    showRightPanel={this.state.show_results}
                    onToggleRightPanel={this.toggleShowResults}
                    footer={
                        !this.state.showNewSite && !this.state.showEditSite && !this.state.showCopySite && (
                            <div style={{margin: 0, padding: 0}}>
                                <h4>Customer Install Sites</h4>
                                <CustomerSiteList
                                    sites={this.state.sites}
                                    sitecopyid={this.state.sitecopyid}
                                    SelectSite={this.SelectSite}
                                    selectedsite={this.state.selectedsite}
                                    changeSelCopy={this.changeSelCopy}
                                    onSave={this.saveSite}
                                    onDelete={this.deleteSite}
                                />
                            </div>
                        )
                    }
                    rightPanel={
                        <CalcResults
                            // Callbacks - must remain as props
                            onChange={this.updateSavings}
                            handleToUpdate={this.updateSavings}
                            // Props not yet in Redux slices
                            has_smart_energy={true}
                            cost={this.state.cost}
                            token={this.state.rest_token}
                            slides={this.state.slides}
                            filelist={this.state.filelist}
                            create_documents={this.state.create_documents}
                            presentation_versions={this.state.presentation_versions}
                            selected_presentation={this.state.selected_presentation}
                            // All other data now comes from Redux via mapStateToProps
                        />
                    }
                />
                <br style={{fontSize: 8}} />
            </div>
        );
    }
}



/*
Add after </Table Container> if you want to add a logo to the page - Taken out as the component is likely
                To either be iframe added or include din reveal for a presentation.

                <Grid container  className={classes.bottomgrid} >
                    <Grid item  ><img src={logo} alt='Edison Solar' className={classes.logo} /></Grid>
                    <Grid item  ><div className={classes.footerText}  ><center>Saving You Money<br/>Helping Save The Planet</center></div></Grid>
                </Grid>
*/
//let theme = createMuiTheme();
//theme = responsiveFontSizes(theme);
const styles = theme => ({
    root: {
        overflowX : 'auto',
        width: '99%',
        backgroundColor: 'white',
        marginLeft: 10,
        marginRight: 10,
        marginTop: 5,
        borderWidth: 2,
        borderColor: '#ff0000',
        maxwidth: '1548px'
    },
    footerText: {
        paddingTop: 15,
        fontSize: 14,
        verticalAlign: 'top',
        alignItems: 'center',

    },
    HTMLTableRowElement: {
        border: 0,
    },
    paper: {
        borderWidth: 2,
        borderColor: 'red'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
    }, 
    logo: {
        width: '80px',
        alignItems: 'flex-start',
    },
    eleconsumpinput:{
        fontSize: 12,
        width: 180,
    },
    voscinput: {
        fontSize: 12,
        width: 50,
    },

    table: {
        width: '100%',
    },
    tablemain: {
        width: '100%',
        border: 0,
        position: 'sticky',
        top: 0,
    },

    leftcell: {
        //width: '38%',
        width: '560px',
        verticalAlign: 'top',
    },
    rightcell: {
        //width: '62%',
        verticalAlign: 'top',
    },
    topgrid: {
        alignItems: 'flex-end',
        marginTop: 0,
        marginBottom: 0,
        paddingTop: 0,
        paddingBottom: 0,
    },
    quote: {
        fontSize: 14,
    },
    quoteref: {
        fontSize: 12,
        backgroundColor: 'lightblue',
    },
    batteryForm: {
        width: '100%',
        fontSize: 14,
    },
    batterySelect: {
        fontSize: 14
    },
    batteryLabel: {
        fontSize: 14,
        fontWeight: 'bold',
        textDecorationLine: 'underline',
    },
    tariffSelect: {
        width: 500,
        fontSize: 12,
        backgroundColor: 'white',
        color: 'black'
    },
    siteSelect: {
        width: 500,
        fontSize: 12,
        backgroundColor: 'white',
        color: 'black'
    },
    supplierTariff: {
        borderWidth: 0,
        borderColor: 'red'
    },
    selfconsumptionForm: {
        marginTop: 15,
        width: 150,
    },
    selfconsumptionSelect: {
        fontSize: 12,
    },
    voForm: {
        width: 200,
    },
    voSelect: {
        fontSize: 10
    },
    supplierTariffContainer: {
        width: '100%',
    },
    lblTariff: {
        width: '100%',
        fontSize: 14
    },
    smallLabel: {
        fontSize: '10px'
    },
    backdrop: {
        backgroundColor: 'white'
    },
    groundWorksm: {
        minWidth: 150,
        fontSize: 14,
    },
    groundworkGrid: {
        marginLeft: 0,
    },
    typoGroundWork: {
        fontSize: 14,
        alignText: 'left',
    },
    spanConfig: {
        marginTop: 20,
        fontWeight: 'bold',
        textDecorationLine: 'underline',
        fontSize: 14,
    },
    frmClass: {
        alignItems: 'left',
        alignText: 'left',
    },
    frmLabel: {
        alignItems: 'flex-start',
        alignText: 'flex-start',
        alignSelf: 'self-start',
        fontSize: '12px'
    },
    batteryQtyLabel: {
        alignSelf: 'self-start',
        fontSize: '12px'      
    },
    frmCheckbox: {
        alignItems: 'flex-start',
        alignText: 'flex-start',
        alignSelf: 'self-start',
        fontSize: '12px',
        paddingTop: '0px',
        paddingBottom: '0px'       
    },
    inverter_table_cell: {
        fontSize: '11px',
        paddingLeft: '5px'
    },
    inverter_table_cell_center: {
        flex: 1,
        fontSize: '11px',
        alignText: 'center',
        alignSelf: 'center',
        alignItems: 'center'
        
    },
    popover: {
        pointerEvents: 'none',
      },
    popaper: {
        padding: theme.spacing(1),
    },

});

// Setup for Redux
const mapStateToProps = (state) => {
    return {
        // Legacy Redux state
        elecrate: state.elecrate,
        electric_estimated: state.electric_estimated,
        conservation_area: state.conservation_area,
        listed_property: state.listed_property,
        deposit_amount: state.deposit_amount,
        customer_message_rep: state.customer_message_rep,
        save_redux: state.save_redux,
        customer2email: state.customer2email,
        customer2name: state.customer2name,
        customer2surname: state.customer2surname,
        customer2title: state.customer2title,
        agreement_confirmsend: state.agreement_confirmsend,
        birdprotection_confirmsend: state.birdprotection_confirmsend,
        fin_monthlypayment: state.fin_monthlypayment,
        fin_totalcost: state.fin_totalcost,
        agreementdata: state.agreementdata,
        mpan_number: state.mpan_number,
        noratedisclaimer: state.noratedisclaimer,
        propertytype: state.propertytype,
        offgrid_system: state.offgrid_system,
        selected_site: state.selected_site,

        // New Redux slices - for saving quote data
        energySlice: state.energy,
        systemSlice: state.system,
        addonsSlice: state.addons,
        financialSlice: state.financial,
        customerSlice: state.customer
    };
};  

const mapDispatchToProps = (dispatch) => ({
    dispatch, // Expose dispatch for new Redux slice actions
    updateelectric_estimated: (...args) => dispatch(updateelectric_estimated(...args)),
    updateelecrate: (...args) => dispatch(updateelecrate(...args)),
    updateconservationarea: (...args) => dispatch(updateconservationarea(...args)),
    updatelistedproperty: (...args) => dispatch(updatelistedproperty(...args)),
    updatedeposit: (...args) => dispatch(updatedeposit(...args)),
    updaterepcustomermsg: (...args) => dispatch(updaterepcustomermsg(...args)),
    updatecustomer2name: (...args) => dispatch(updatecustomer2name(...args)),
    updatecustomer2surname: (...args) => dispatch(updatecustomer2surname(...args)),
    updatecustomer2title: (...args) => dispatch(updatecustomer2title(...args)),
    updatecustomer2email: (...args) => dispatch(updatecustomer2email(...args)),
    agreementcheckconfirmed: (...args) => dispatch(agreementcheckconfirmed(...args)),
    birdprotectionconfirmed: (...args) => dispatch(birdprotectionconfirmed(...args)),
    updatefinmonthlypayment: (...args) => dispatch(updatefinmonthlypayment(...args)),
    updatefintotalcost: (...args) => dispatch(updatefintotalcost(...args)),
    updateagreementdata: (...args) => dispatch(updateagreementdata(...args)),
    updateoffgridsystem: (...args) => dispatch(updateoffgridsystem(...args)),
    updatempan: (...args) => dispatch(updatempan(...args)),
    updatenoratedisclaimer: (...args) => dispatch(updatenoratedisclaimer(...args)),
    updatepropertytype: (...args) => dispatch(updatepropertytype(...args)),
    updateselectedsite: (...args) => dispatch(updateselectedsite(...args))
})

// Connect our Redux stores to the Component
export default withStyles(styles)(connect( 
        mapStateToProps,
        mapDispatchToProps
    ) (QuotePageApp));